import React, { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Table from '../elements/Table';

function Projects() {

useEffect(() => {
  window.scrollTo(0, 0);
});

  return (
    <div>
      <p
          className="warning-resolution"
        >
          To view this page, a minimum resolution of
          320x500 pixels is required.
      </p>
      <section className="section-index">
        <div className="container-projects">
          <Header />
          <section className="section-projects">
            <h1
              className="page-header page-header-projects"
            >
              Projetos desenvolvidos
            </h1>
            <Table />
          </section>
          <Footer />
        </div>
      </section>
    </div>
  );
}

export default Projects;
